import { FormControlLabel, FormControlLabelProps, styled, useRadioGroup } from "@mui/material";

/* eslint-disable quote-props */
import React from "react";

interface StyledFormControlLabelProps extends FormControlLabelProps {
  checked: boolean;
  customStyle?: boolean;
}

const StyledFormControlLabel = styled((props: StyledFormControlLabelProps) => (
  <FormControlLabel {...props} />
))(({ theme, checked, customStyle }) => ({
  textAlign: "center",
  display: "grid",
  margin: 0,
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: checked ? theme.palette.primary.main : theme.palette.taupe.dark,
  borderRadius: "0.5rem",
  backgroundColor: checked ? theme.palette.primary.light : "#fff",
  "&:hover": {
    backgroundColor: checked ? "" : theme.palette.grey[200],
  },
  "&.Mui-disabled": {
    backgroundColor: "#DAD7D6",
    borderColor: "#908E8D",
    opacity: 1,
  },
  height: customStyle ? "92px" : "74.182px",
  "& .MuiRadio-root": {
    display: "none",
  },
  "& .MuiFormControlLabel-label": {
    fontSize: "12px",
    color: "#000000",
    "&.Mui-disabled": {
      color: "#000000",
    },
  },
}));


const MyFormControlWhiteLabel = (props: FormControlLabelProps & { customStyle?: boolean }) => {
  const radioGroup = useRadioGroup();
  let checked = false;

  if (radioGroup) {
    checked = radioGroup.value === props.value;
  }

  return <StyledFormControlLabel checked={checked} {...props} />;
};

export default MyFormControlWhiteLabel;
